import {
  ComponentDeploymentRequestListPageState,
  DeploymentRequestRowStatus,
} from ".";
import {
  EnvTypeCd,
  InDefCommonFlagType,
} from "../../util/general-code/enums/general-codes";

const displayColumn = [
  { label: "Review Comment", value: "reviewComment" },
  { label: "Request No", value: "dplymntReqSeq" },
];

export const ComponentDeploymentRequestListPageInitialState: ComponentDeploymentRequestListPageState =
  {
    /**
     * Page List
     */

    deploymentRequestList: [],
    dataList: {
      edhProtocolList: [],
    },
    searchForm: {
      dipByRegion: "",
      componentId: "",
      protocol: "",
      scheduledDeploymentDate: {
        startDate: "",
        endDate: "",
      },
      environment: EnvTypeCd.STG,
      incClosed: false,
    },
    isEdited: false,
    fieldPath: {
      dipByRegion: "dipByRegion",
      componentId: "componentId",
      protocol: "protocol",
      scheduledDeploymentDate: "scheduledDeploymentDate",
      environment: "environment",
    },
    displayColumn: displayColumn,
  };

export const INIT_DEPLOY_REQ_ROW_STATUS: DeploymentRequestRowStatus = {
  isSelected: InDefCommonFlagType.NO,
  isApproved: "",
  errorColumnList: [],
  errorMessage: "",
  messageList: [],
};
